import React from 'react';

import nationalTechHonorSocietyLogo from '../../assests/nths-logo.png';

export function NationalTechHonorSocietyLogo({ style }){
  return (
    <img 
      src={nationalTechHonorSocietyLogo} 
      alt="National Technical Honor Society logo"
      style={style} 
    />
  );
}